import { render, staticRenderFns } from "./ContestNameView.vue?vue&type=template&id=16fd3bf9&scoped=true&"
import script from "./ContestNameView.vue?vue&type=script&lang=js&"
export * from "./ContestNameView.vue?vue&type=script&lang=js&"
import style0 from "./ContestNameView.vue?vue&type=style&index=0&id=16fd3bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd3bf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
